import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Accelerator } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService): GridSetup<Accelerator> {

	return {
		rowName: { singular: 'Accelerator', plural: 'Accelerators' },
		getRowKey: row => '' + row.accId,
		stateKey: 'accelerators-accelerator-grid',
		renderRowClasses: row => row.canceled ? ['grid-cell-strikethrough', 'grid-cell-red-text'] : [],
		actions: getActions(),
		buttons: [],
		columns: getColumns(util, app),
	}
}
